/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Redeem_TitleInputs */

const en_us2_invite_redeem_title = /** @type {(inputs: Invite_Redeem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Did someone invite you?`)
};

const pt_br2_invite_redeem_title = /** @type {(inputs: Invite_Redeem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguém te convidou?`)
};

const pt_pt2_invite_redeem_title = /** @type {(inputs: Invite_Redeem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguém te convidou?`)
};

/** @type {(inputs: Invite_Redeem_TitleInputs) => LocalizedString} */
const es_419_invite_redeem_title = en_us2_invite_redeem_title;

/** @type {(inputs: Invite_Redeem_TitleInputs) => LocalizedString} */
const fr_fr2_invite_redeem_title = en_us2_invite_redeem_title;

/** @type {(inputs: Invite_Redeem_TitleInputs) => LocalizedString} */
const de_de2_invite_redeem_title = en_us2_invite_redeem_title;

/** @type {(inputs: Invite_Redeem_TitleInputs) => LocalizedString} */
const it_it2_invite_redeem_title = en_us2_invite_redeem_title;

/**
* | output |
* | --- |
* | "Did someone invite you?" |
*
* @param {Invite_Redeem_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_redeem_title = /** @type {((inputs?: Invite_Redeem_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Redeem_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_redeem_title(inputs)
	if (locale === "es-419") return es_419_invite_redeem_title(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_redeem_title(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_redeem_title(inputs)
	if (locale === "de-DE") return de_de2_invite_redeem_title(inputs)
	if (locale === "it-IT") return it_it2_invite_redeem_title(inputs)
	return en_us2_invite_redeem_title(inputs)
});
export { invite_redeem_title as "invite.redeem_title" }